import React from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import { PrismicLink } from '@prismicio/react'

const PageHeader = ({ pageData }) => {
  let images = pageData.page_image.thumbnails
  if (pageData.page_image.thumbnails.mobile.gatsbyImageData) {
    images = withArtDirection(getImage(pageData.page_image.gatsbyImageData), [
      {
        media: '(max-width: 768px)',
        image: getImage(pageData.page_image.thumbnails.mobile.gatsbyImageData)
      }
    ])
  }
  let position = 'items-center'
  if (pageData.image_position === 'Bottom') {
    position = 'items-end'
  }
  if (pageData.image_position === 'Top') {
    position = 'items-start'
  }

  return (
    <div className='overflow-hidden'>
      <div className={`h-full hero relative md:max-h-[432px] min-w-full overflow-hidden flex ${position}`}>
        {pageData.page_image.gatsbyImageData && (
          <GatsbyImage loading='eager' className='md:max-h-[432px] art-directed h-auto w-full relative z-10' image={images} alt={pageData.page_image.alt || ''} />
        )}
        <div className='flex flex-col items-center justify-center gap-3 absolute inset-x-0 top-auto bottom-10 w-full z-20'>
          {pageData.page_button_link?.url && (
            <PrismicLink field={pageData.page_button_link} className='button w-80 text-center button-brand text-lg'>
              {pageData.page_button_text}
            </PrismicLink>
          )}
          {pageData.secondary_button_link?.url && (
            <PrismicLink field={pageData.secondary_button_link} className='button w-80 text-center button-brand text-lg'>
              {pageData.secondary_button_text}
            </PrismicLink>
          )}
        </div>
      </div>
      {pageData.page_title?.text && <h1 className='fade-in max-w-screen-xl mx-auto px-4 text-center mb-0 mt-12 z-10'>{pageData.page_title.text}</h1>}
    </div>
  )
}

export default PageHeader
